<template>
  <c-button ref="button" v-bind="$props"></c-button>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, baseComponents } from '@tencent/ceiba-base-components';
// import { componentBaseMixin, baseComponents } from '../../../../ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';

export default {
  name: 'CPopupReward',
  components: {
    [button.name]: button,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'popup-reward-',
    };
  },
  computed: {},
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.$refs.button.setClickHandler(this.doGetReward, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        enableGame: this.configurationData.enableGame,
        // todo 和平精英业务活动需要绑定角色 后续configurationData配置
        forceRole: this.$actInfo?.ast === 'cjm',
      });
    },
    async doGetReward() {
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
      const params = {
        activity_id: `${this.actInfo.activity_id}`,
        business_id: this.actInfo.ast,
        workflow_id: this.configurationData.flowID ? `${this.configurationData.flowID}` : '',
        resource_id: this.configurationData.resource_id ? `${this.configurationData.resource_id}` : '',
        flow_version: this.actInfo.flow ? parseInt(this.actInfo.flow, 10) : 1,
        // flow_version: 2,
        scene: this.configurationData.scene ? `${this.configurationData.scene}` : 'ceiba_act',
      };
      const { moduleId = '', category = '', iExcludePackageId = '' } = this.configurationData;
      if (typeof moduleId === 'string' && moduleId.length > 0) {
        params.moduleId = moduleId;
      }
      if (typeof category === 'string' && category.length > 0) {
        params.category = category;
      }
      if (typeof iExcludePackageId === 'string' && iExcludePackageId.length > 0) {
        params.iExcludePackageId = iExcludePackageId;
      }
      const gameCode = this.configurationData.game_code ? this.configurationData.game_code : this.actInfo.game_code;
      const fontColor = this.configurationData.recordsFontColor;
      const hidePackageIds = (this.configurationData.hidePackageIds || '').split(',');
      const pageSize = this.configurationData.popupPageSize || 6; // 每页记录数可配置,默认6
      let { positionType = 'center' } = this.configurationData;
      positionType = positionType ? positionType : 'center';
      const {
        recordsFontColor,
        recordBackgroundColor = 'rgba(247,249,250,1)',
        packageClaimBackgroundImage,
      } = this.configurationData;
      const {
        titleStyle = {
          color: '#BB6B2F',
          fontSize: '0.40rem',
          fontWeight: '500',
          fontFamily: '微软雅黑',
        }, operateStyle = {
          color: '#BB6B2F',
          fontSize: '0.24rem',
          fontWeight: '400',
          fontFamily: '微软雅黑',
        },
      } = this.styles;
      if (positionType === 'center') {
        baseComponents.pacakgeClaimRecords.showPackageClaimRecords(gameCode, {
          fontColor,
          hidePackageIds,
          params,
          pageSize,
          option: Object.assign({}, this.dialogConfig, {
            header: '获奖记录',
            fotter: false,
            titleStyle,
            operateStyle,
            height: this.deviceMode === 'pc' ? '360px'
              : this.configurationData.popupHeightH5 || '6.85rem', // h5弹窗高度可配置,默认6.85rem
            width: this.deviceMode === 'pc' ? '720px'
              : this.configurationData.popupWidthH5 || '7.2rem', // h5弹窗宽度可配置,默认7.2rem
            dialogStyle: Object.assign({}, this.dialogConfig?.dialogStyle || {}, {
              color: recordsFontColor || '#000000',
              backgroundImage: `url(${this.configurationData?.packageClaimBackgroundImage})`,
            }),
          }),
        });
        return;
      }

      baseComponents.giftRewardRecords.showGiftRewardRecords(gameCode, {
        fontColor,
        hidePackageIds,
        params,
        pageSize,
        recordBackgroundColor,
        option: Object.assign({}, this.dialogConfig, {
          header: '获奖记录',
          fotter: false,
          positionType: 'bottom',
          titleStyle,
          operateStyle,
          closeStyle: this.dialogConfig?.backgroundImage ? this.dialogConfig.closeStyle : null,
          closeLocation: 'top-right-isBottom',
          height: this.deviceMode === 'pc' ? '360px'
            : this.configurationData.popupHeightH5 || '6.25rem', // h5弹窗高度可配置,默认6.85rem
          width: this.deviceMode === 'pc' ? '750px' : '7.5rem',
          dialogStyle: Object.assign({}, this.dialogConfig?.dialogStyle || {}, {
            color: recordsFontColor || '#242424',
            padding: 0,
            // backgroundImage: packageClaimBackgroundImage ? `url(${packageClaimBackgroundImage})` : 'none',
            backgroundColor: packageClaimBackgroundImage ? 'transparent' : '#ffffff',
          }),
        }),
      })
      ;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
